<app-toast aria-live="polite" aria-atomic="true"></app-toast>

@if (!(this.fullscreen | async)) {
  <app-sidebar role="navigation"></app-sidebar>
}
<main role="main" class="col h-100">
  <app-toast-validation />
  <app-version-banner />
  <router-outlet></router-outlet>
  <ngx-ui-loader></ngx-ui-loader>
</main>
